import BusinessUnitTag from 'ui-business-units-lib/components/BusinessUnitTag';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useFetchBusinessUnits } from './hooks/useFetchBusinessUnits';
import CampaignsPlatformLabelPopoverProperty from './CampaignsPlatformLabelPopoverProperty';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CampaignsPlatformLabelPopoverBusinessUnit({
  businessUnitId
}) {
  const {
    data,
    loading
  } = useFetchBusinessUnits();
  if (loading || !data || data.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(CampaignsPlatformLabelPopoverProperty, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaignSelect.popover.businessUnit_buv2"
    }),
    value: /*#__PURE__*/_jsx(BusinessUnitTag, {
      buId: businessUnitId,
      buOptions: data
    })
  });
}